export default __webpack_public_path__ + "static/media/single-project-page-05-img-24.9bdd8f03.jpg";